import { postRequest } from './axiosWithAuth';
export const getToken = () => {
    let tokenExists = !!localStorage.getItem('token');
    if (tokenExists)
        postRequest('/refresh');
    return tokenExists
}